import React, { Component } from 'react'
import { Label } from 'reactstrap'
import { observer } from 'mobx-react'
import moment from 'moment'

@observer
export default class CardVeiculos extends Component {

    constructor(props) {
        super(props)

        //console.log(this.props)

        this.renderDados = this.renderDados.bind(this)
    }

    renderDados() {
        if(!this.props.dados || this.props.dados.length === 0){
            return (
                <React.Fragment>
                    <div className="card-veiculos--dados">
                        <span className="card-veiculos--informacao__vazio">
                            Nenhum registro encontrado.
                        </span>
                    </div>
                    <div className="card-veiculos--header">
                        <span>0</span> 
                         Veículos encontrados
                    </div>
                </React.Fragment>
            )
        }else{
            return(
                <React.Fragment>
                    
                    <div className="card-veiculos--dados">
                        {
                            this.props.dados.map((dado, index) => {
                                return (
                                    <div key={index} className={`card-veiculos--informacao ${index % 2 ? "impar" : "par"}`}>
                                        <Label className="card-veiculos--informacao__placa">
                                            {dado.Placa}
                                        </Label>
                                        <div className="card-veiculos--informacao__data">
                                            {dado.Data ? moment(dado.Data).format("DD MMM, YYYY - HH:mm").toUpperCase() : "---"}
                                        </div>
                                    </div>
                                )
                            })

                        }
                    </div>
                    <div className="card-veiculos--header">
                        <span>{this.props.dados.length}</span> 
                        {
                            this.props.dados.length === 1
                            ?"Veículo encontrado"
                            :"Veículos encontrados"
                        }
                    </div>
                </React.Fragment>
            )
        }
    }

    render() {
        return (
            <div className="card-veiculos">
                {this.renderDados()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/veiculos/components/CardVeiculos.js